import { render } from "./MaterialRequestsAdminFilters.vue?vue&type=template&id=32cc5ecc&scoped=true"
import script from "./MaterialRequestsAdminFilters.vue?vue&type=script&lang=js"
export * from "./MaterialRequestsAdminFilters.vue?vue&type=script&lang=js"

import "./MaterialRequestsAdminFilters.vue?vue&type=style&index=0&id=32cc5ecc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cc5ecc"]])

export default __exports__